import { createContext, useContext } from 'react';
import { IResellerConfig } from '~/config/shared/reseller-config';
import { INavBarConfig } from '~/src/dash/views/navbar/configs/defaultCfg';

interface INavBarContext {
  cfg: INavBarConfig;
  resellerCfg: IResellerConfig;
  isDarkTheme: boolean;
  activeSubMenu: string;
  setActiveSubMenu: React.Dispatch<React.SetStateAction<string>>;
  resizeAction: Record<string, string>;
  setResizeAction: React.Dispatch<React.SetStateAction<Record<string, string>>>;
}

export const NavBarContext = createContext({} as INavBarContext);
export const useNavBarStore = (): INavBarContext => useContext(NavBarContext);
